module.exports = __webpack_public_path__ + "media/images/ui-icons_ffffff_256x240-e716c93fb8aa23c1e10b5185a8191dbf.png";